import React from "react";

function Chair({ item, isRow, setSelectedSeat, is_selected }) {
  return (
    <>
      {isRow && <div className="w-100" />}

      {item.type === "empty" ? (
        <div className="d-inline-block fs-7 me-1 chair" />
      ) : item.type === "title" ? (
        <div className="d-inline-block me-1 text-center align-items-center chair position-relative">
          <span
            className={
              "position-absolute d-flex place-self-center align-self-center mb-0 mx-auto " +
              item.class
            }
            style={{ placeSelf: "center" }}
          >
            {item.value}
          </span>
        </div>
      ) : item.type === "text" ? (
        <div className="btn p-0 d-inline-block fs-7 me-1 text-center border-0 cursor-auto chair align-content-center">
          {item.name || item.number}
        </div>
      ) : item.type === "empty_half" ? (
        <div
          className="d-inline-block fs-7 me-1 chair-half"
          value={item.status}
        />
      ) : item.type === "select" ? (
        <div
          className={`btn border-0 shadow-sm p-0 d-inline-block align-content-center fs-7 me-1 chair cursor-pointer ${
            item.status === "sold"
              ? "bg-red text-white"
              : is_selected
              ? "bg-light-green text-white"
              : item.status === "reserved"
              ? "bg-warning"
              : item.status === "blocked"
              ? "bg-dark text-white"
              : "bg-gray"
          }`}
          data-id={item.id}
          data-status={item.status}
          onClick={setSelectedSeat}
        >
          {item.name || item.number}
        </div>
      ) : null}
    </>
  );
}

export default React.memo(Chair);
